import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as authApi from '../../lib/api/auth';


const [LIST_USER_SCHEDULES, LIST_USER_SCHEDULES_SUCCESS, LIST_USER_SCHEDULES_FAILURE] =
  createRequestActionTypes('user/LIST_USER_SCHEDULES');
export const listSchedules = createAction(LIST_USER_SCHEDULES, (searchData)=>(searchData));
const listSchedulesSaga = createRequestSaga(LIST_USER_SCHEDULES, authApi.getSchedules);

const UNLOAD_USER_SCHEDULES = 'user/UNLOAD_USER_SCHEDULES';
export const unloadUserSchedules = createAction(UNLOAD_USER_SCHEDULES);

export function* schedulesSaga() {
  yield takeLatest(LIST_USER_SCHEDULES, listSchedulesSaga);
}

const initialState = {
  schedules: null,
  error: null,
};

const schedules = handleActions(
  {
    [LIST_USER_SCHEDULES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      schedules: data.list.map((schedule) => ({
        id:schedule.id,
        type:schedule.type,
        taskUuid:schedule.taskUuid,
        title:schedule.title,
        allDay:schedule.allDay,
        start:schedule.start,
        end:schedule.end,
        usrNm:schedule.usrNm,
        gradeNm:schedule.gradeNm,
        dptNm:schedule.dptNm,
        backgroundColor:(schedule.type==='tech')?'#ffc107':'#ffcf33',
        borderColor:(schedule.type==='tech')?'#ffc107':'#ffcf33'
      })),
      error: null,
    }),
    [LIST_USER_SCHEDULES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_USER_SCHEDULES]: (state) => ({
      ...state,
      schedules: null,
      error: null,
    }),
  },
  initialState,
);

export default schedules;
